import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateTranscriptionMutationVariables = Types.Exact<{
  assetId: Types.Scalars['UUID']['input'];
  locale: Types.Scalars['String']['input'];
  mimeType: Types.Scalars['String']['input'];
  fileName: Types.Scalars['String']['input'];
  hasOffset?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CreateTranscriptionMutation = { __typename?: 'Mutation', createTranscription?: { __typename?: 'CreateTranscriptionPayload', transcription?: { __typename?: 'Transcription', id?: string | null, captionUploadUrl?: string | null } | null } | null };


export const CreateTranscription = /*#__PURE__*/ gql`
    mutation CreateTranscription($assetId: UUID!, $locale: String!, $mimeType: String!, $fileName: String!, $hasOffset: Boolean = false) @stewardship(stewards: [VIEWER]) {
  createTranscription(
    input: {assetId: $assetId, locale: $locale, mimeType: $mimeType, name: $fileName, hasOffset: $hasOffset}
  ) {
    transcription {
      id
      captionUploadUrl
    }
  }
}
    ` as unknown as DocumentNode<CreateTranscriptionMutation, CreateTranscriptionMutationVariables>;

          

          export const useCreateTranscriptionMutation = (options?:MutationHookOptions<CreateTranscriptionMutation, CreateTranscriptionMutationVariables>) => useMutation(CreateTranscription, options);
          

          export type CreateTranscriptionMutationOptions = MutationHookOptions<CreateTranscriptionMutation, CreateTranscriptionMutationVariables>;

          

          export type CreateTranscriptionMutationResult = ReturnType<typeof useCreateTranscriptionMutation>[1];

          
